import { render } from "./DeckSettingsModal.vue?vue&type=template&id=4b8eb702&scoped=true&ts=true"
import script from "./DeckSettingsModal.vue?vue&type=script&lang=ts"
export * from "./DeckSettingsModal.vue?vue&type=script&lang=ts"

import "./DeckSettingsModal.vue?vue&type=style&index=0&id=4b8eb702&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8eb702"]])

export default __exports__